import SectionFirstPage from '@/components/common/SectionFirstPage';
import SectionEnterpriseSolutionsCloudITServices from '@/components/pages/EnterpriseSolutionsCloudITServices/SectionEnterpriseSolutionsCloudITServices';
import React from 'react';
import { useTranslation } from 'react-i18next';

const EnterpriseSolutionsCloudITServices = () => {
  const { t } = useTranslation();
  return (
    <div>
      <SectionFirstPage
        title={
          <h1>
            {t('Enterprise Solutions')}
            <br />
            {t('Cloud & IT')}
            <br />
            <span>{t('Services')}</span>
          </h1>
        }
        desc={t(
          'Scalable, secure, and future-ready — Warppipe delivers enterprise-grade solutions and cloud services that power business growth and digital transformation.'
        )}
      />
      <SectionEnterpriseSolutionsCloudITServices />
    </div>
  );
};

export default React.memo(EnterpriseSolutionsCloudITServices);
